<template>
    <div id="page">
        <div class="page">
            <div class="indicator">
                <h3>プレビュー表示中</h3>
                <button type="button" class="btn btn-outline-light btn-sm" @click="close()">
                    ウインドウを閉じる
                </button>
            </div>
            <div class="container" ref="preview_container" id="preview_container" :class="{'vertical': $store.state.is_horizontal == 0}">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <section-body
                            :section="section" :prev="true" :preview="true"></section-body>
                    </div>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            loader="bars"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
#page {
    padding-top: 1px;
    transition: 0.2s ease;
    min-height: calc(100vh - 42px);
    &.closed {
        padding-right: 0px;
    }
    .page {
        padding: 0 50px 40px;
        height: calc(100vh - 45px);
        .indicator {
            padding: 1.5rem;
            margin: 0 0 2rem;
            text-align: center;
            color: snow;
            background-color: #5e5e50;
            border-radius: 0 0 1rem 1rem;
        }
    }
}
.vertical {
    justify-content: center;
    max-width: calc(100vw - 150px);
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display:none;
    }
    margin-top: 3rem;
    a:hover {
        text-decoration: overline;
    }
}
@media screen and (max-width: 770px) {
    #page {
        .page {
            padding: 0 0 30px;
            .indicator {
                padding: .5rem;
                h3 {
                    font-size: 1.2rem;
                }
                margin: 0 0 1rem;
                text-align: center;
                color: snow;
                background-color: #5e5e50;
                border-radius: 0 0 1rem 1rem;
            }
        }
    }
    .col-lg-12 {
        padding: 0;
    }
    .vertical {
        max-width: 90% ;
    }
}
</style>

<script>
import sectionBody from "pages/author/page/section-body";
export default {
    components: {
        sectionBody,
    },
    data() {
        return {
            section: {},
            isLoading: false,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/book/preview/get?book_id=" + this.$route.query.book_id).then(res => {
                if (res.data) {
                    this.section = res.data;
                }
                this.isLoading = false;
            }).catch(err => {
                alert.err(err.response);
                this.isLoading = false;
            });
        },
        close() {
            window.opener.focus();
            window.close();
        },
        showLayout() {
            $("#layout-modal").modal();
        },
        onScroll(ev) {
            this.$refs.preview_container.scrollLeft = this.$refs.preview_container.scrollLeft - ev.deltaY;
        }
    },
    mounted() {
        document.querySelector("#preview_container").onwheel = this.onScroll;
        this.isLoading = true;
        this.load();
    }
}
</script>